import { render } from "./SelectValuta.vue?vue&type=template&id=625f0710"
import script from "./SelectValuta.vue?vue&type=script&lang=js"
export * from "./SelectValuta.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__